const Tag = ({ acronym = false, name }) => (
  <pre className={`list-paragraph__tag ${acronym ? 'list-paragraph__tag--acronym' : ''}`}>{name}</pre>
)

export default Tag